var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgDocumentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8066",
    "data-name": "Group 8066",
    transform: "translate(-4142 -13315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-document",
    transform: "translate(4142 13315)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 24,
    height: 24,
    fill: "#0071b9",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M19.143,6.371V6.3L16.3,3.347H8.4V16.581H19.128l.015-9.164h1.342l0,9.153a1.381,1.381,0,0,1-1.352,1.4H8.236a1.2,1.2,0,0,1-1.174-1.219V3.173A1.2,1.2,0,0,1,8.236,1.954h8.016v-.01h.105a1.145,1.145,0,0,1,.83.357L20.14,5.367a1.235,1.235,0,0,1,.344.862v.144ZM17.707,7.635H9.8V8.68h7.905Zm0,2.264H9.8v1.045h7.905ZM9.8,13.207h7.905V12.162H9.8Z",
    transform: "translate(-1.761 2.056)",
    fill: "#0071b9"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDocumentIcon);
export default __webpack_public_path__ + "static/media/img-document-icon.314517b7.svg";
export { ForwardRef as ReactComponent };